module.exports = __webpack_public_path__ + "img/wx_dpt_bc@2x.1d1bba3d.png";